<template>
  <v-lazy-image
    v-if="hasLogo"
    class="avatar"
    :class="`avatar-${avatarSize}`"
    :src="logoUrl"
    @error="hasLogo = false"
  />
  <span
    v-else
    class="avatar"
    :class="`avatar-${avatarSize}`"
  >
    {{ !hasLogo? getAcronym : '' }}
  </span>
</template>

<script>
import VLazyImage from 'v-lazy-image/v2';

export default {
  props: {
    company: {
      type: Object,
      default: () => {},
    },
    avatarSize: {
      type: String,
      default: 'md',
    },
  },
  components: {
    VLazyImage,
  },
  data() {
    return {
      hasLogo: true,
    };
  },
  computed: {
    logoUrl() {
      return `${process.env.VUE_APP_SERVER_URL}/logos/${this.company.domain}`;
    },
    getAcronym() {
      const str = this.company.name;
      const matches = str.match(/\b(\w)/g);
      return matches.join('').substring(0, 4);
    },
  },
};
</script>
